export function signedUrlForDownload(download) {
  if (!download || !download.download || download.download.signedUrl === '') {
    console.warn('missing download or signed url', download);
    return undefined;
  }
  if (!download.isFinalized) {
    console.warn('entity not finalized - ignoring signed url', download);
    return undefined;
  }
  return download.download.signedUrl;
}

export function downloadURLForEntity(entity) {
  if (entity && entity.downloadsWereExpanded) {
    if (entity.expandedDownloadsList && entity.expandedDownloadsList.length > 0) {
      const download = entity.expandedDownloadsList[0];
      const url = signedUrlForDownload(download);
      if (url) {
        return url;
      }
    }
  }
  console.warn('download link missing or not finalized', entity);
  return undefined;
}

export function downloadURLsForEntityDerivatives(entity) {
  if (entity && entity.derivativesWereExpanded) {
    if (entity.expandedDerivativesList && entity.expandedDerivativesList.length > 0) {
      const downloadURLs = [];
      for (let x = 0; x < entity.expandedDerivativesList.length; x += 1) {
        const download = entity.expandedDerivativesList[x];
        const url = signedUrlForDownload(download);
        if (url) {
          downloadURLs.push(url);
        }
      }
      return downloadURLs;
    }
  }
  console.warn('derivative download link missing or not finalized', entity);
  return [];
}

export function entityIsThumb(entity) {
  // TODO: i need a WAY better way to determine format type. mime?
  // need other formats added
  const imageFormats = ['png', 'jpg', 'jpeg', 'gif'];
  if (entity && entity.format) {
    return imageFormats.some((format) => format === entity.format);
  }
  return false;
  // return entity && entity.format === 'tiff' && downloadURLForEntity(entity);
}

export function entityIsVideo(entity) {
  // TODO: i need a WAY better way to determine format type. mime?
  return entity && entity.format === 'h264' && downloadURLForEntity(entity);
}

export function firstVideoDerivativeOfEntity(entity) {
  if (entity && entity.expandedDerivativesList && entity.expandedDerivativesList.length > 0) {
    return entity.expandedDerivativesList.find((derivative) => entityIsVideo(derivative.entity));
  }
  return undefined;
}

export function derivativeVideoURLsForVideoPlayer(entity) {
  const wrappedURLs = [];
  if (entity && entity.expandedDerivativesList && entity.expandedDerivativesList.length > 0) {
    // TODO: finish this
    const videoDerivatives = entity.expandedDerivativesList.filter((derivative) => derivative && entityIsVideo(derivative.entity));
    videoDerivatives.forEach((derivative) => {
      if (derivative.entity) {
        const url = downloadURLForEntity(derivative.entity);
        if (url) {
          wrappedURLs.push({
            type: 'video/mp4', // TODO: video type/format
            src: url,
          });
        }
      }
    });
  }
  console.info('computed derivative urls for vid player', wrappedURLs);
  return wrappedURLs;
}

// filterEntitiesByVideoOnly filters the entities by video
export function filterEntitiesByVideoOnly(entities) {
  return entities.filter((ent) => entityIsVideo(ent));
}

export function entityVideoURLs(entities) {
  const jobVideos = [];
  entities.forEach((ent) => {
    if (entityIsVideo(ent)) {
      const url = downloadURLForEntity(ent);
      if (url) {
        jobVideos.push({
          type: 'video/mp4', // TODO: video type/format
          src: url,
        });
      }
    }
  });
  console.info('computed video urls for job', jobVideos);
  return jobVideos;
}

export function entityThumbURLs(entities) {
  const jobThumbs = [];
  entities.forEach((ent) => {
    if (entityIsThumb(ent)) {
      const url = downloadURLForEntity(ent);
      // TODO: do thumbs need a "type" value like our video urls in entityVideoURLs
      if (url) {
        jobThumbs.push(url);
      }
    }
  });
  console.info('computed thumbs for job', jobThumbs);
  return jobThumbs;
}

export function entityHasVideoDerivs(entity) {
  // TODO: by computing videos this way - we force the list of thumb urls to be built twice because the list is disposed of. not efficent.
  const urls = derivativeVideoURLsForVideoPlayer(entity);
  return urls && urls.length > 0;
}

export function derivativeThumbsForEntity(entity) {
  const wrappedURLs = [];
  if (entity && entity.expandedDerivativesList && entity.expandedDerivativesList.length > 0) {
    const thumbDerivs = entity.expandedDerivativesList.filter((derivative) => derivative && entityIsThumb(derivative.entity));
    thumbDerivs.forEach((derivative) => {
      if (derivative.entity) {
        const url = downloadURLForEntity(derivative.entity);
        wrappedURLs.push(url);
        // if (url) {
        //   wrappedURLs.push({
        //     type: '', // TODO: thumb type/format
        //     src: url,
        //   });
        // }
      }
    });
  }
  console.info('computed derivative urls for thumbs', wrappedURLs);
  return wrappedURLs;
}

export function firstThumbForEntity(entity) {
  const thumbs = derivativeThumbsForEntity(entity);
  if (thumbs && thumbs.length > 0) {
    return thumbs[0];
  }
  return undefined;
}

export function entityHasThumbDerivs(entity) {
  // TODO: by computing hasThumbs this way - we force the list of thumb urls to be built twice because the list is disposed of. not efficent.
  const urls = derivativeThumbsForEntity(entity);
  return urls && urls.length > 0;
}
